export default {
    apiSettings: {
        title: 'API Settings',
        tabs: {
            prod: 'Production',
            test: 'Test'
        },
        security: {
            title: 'Security Settings',
            accessKey: 'Access Key (AK)',
            secretKey: 'Secret Key (SK)',
            view: 'View',
            hide: 'Hide',
            reset: 'Reset'
        },
        callback: {
            title: 'Callback URL Settings',
            prodUrl: 'Production Callback URL:',
            prodDesc: 'The callback address for the prod environment',
            testUrl: 'Test Callback URL:',
            testDesc: 'The callback address for the test environment',
            save: 'Save Callback URLs'
        },
        ip: {
            title: 'IP Settings',
            whitelist: 'Whitelist IP Addresses (one per line):',
            whitelistExtra: 'Please enter IP addresses to be added to the whitelist, one IP address per line',
            placeholder: '192.168.1.1\n10.0.0.1\n172.16.0.1',
            saveProd: 'Save Prod IP Settings',
            saveTest: 'Save Test Settings'
        },
        reset: {
            title: 'Reset AK/SK',
            warning: 'After resetting, new AK/SK will be generated, and the original AK/SK will become invalid. Please select the verification code receiving method:',
            phone: 'Receive by Phone',
            email: 'Receive by Email',
            phonePlaceholder: 'Phone Number',
            emailPlaceholder: 'Email',
            verificationCode: 'Please enter verification code',
            sendCode: 'Send Code',
            cancel: 'Cancel',
            confirm: 'Confirm Reset'
        },
        resetSuccess: {
            title: 'Reset Successful',
            successTitle: 'Reset successful! New SK is:',
            warning: 'Please keep it safe and never disclose it!',
            ok: 'I Understand'
        },
        messages: {
            codeSent: 'Verification code has been sent to your {target}',
            codeSendFailed: 'Failed to send verification code',
            codeRequired: 'Please enter verification code',
            resetFailed: 'Reset failed',
            noConfig: 'No API configuration available',
            callbackSaveSuccess: 'Callback URLs saved successfully',
            callbackSaveFailed: 'Save failed',
            ipSaveSuccess: 'IP settings saved successfully',
            ipSaveFailed: 'Save failed',
            loadFailed: 'Failed to load configuration information'
        }
    }
}